module.exports = __webpack_public_path__ + "static/media/SharpSans-Medium.6a84be49.woff";